const ACCOUNT_TYPE = {
    Entity: 'Business',
};

export default ACCOUNT_TYPE;
